module.exports = __webpack_public_path__ + "static/media/comment-question.1be2da82.svg";